export const imageRegex = /(jpg|jpeg|png)/
export const pdfRegex = /pdf/
export const videoRegex = /(mp4|mpeg|mpg|avi|mov)/

export const kreaFileAcceptedFiles = {
  image: imageRegex,
  pdf: pdfRegex,
  video: videoRegex
}
